import Vue from 'vue'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import OptionMenu from '../../components/option-menu'
import PageHeader from '../../components/page-header'
import VDialog from '../../components/v-dialog'

import {
  Aside,
  Avatar,
  Backtop,
  Button,
  Checkbox,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Header,
  Icon,
  Image,
  Input,
  Loading,
  Main,
  Menu,
  MenuItem,
  Submenu,
  Message,
  MessageBox,
  Option,
  OptionGroup,
  Pagination,
  Popover,
  Row,
  Scrollbar,
  Select,
  Switch,
  Table,
  TableColumn,
  Tag,
  TimeSelect,
  Radio,
  RadioGroup,
  RadioButton,
  Progress,
  Upload,
  Link,
  Tabs,
  TabPane,
  InputNumber,
  Notification,
  Alert,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Card,
  Result
} from 'element-ui'

import './element-variables.scss'

Vue.use(OptionMenu)
Vue.use(PageHeader)
// 设置语言
locale.use(lang)

Dialog.props.closeOnClickModal.default = false
Dialog.props.modalAppendToBody.default = false
// Dialog.props.modal.default = false;

Vue.prototype.$ELEMENT = { size: 'mini' }

Vue.use(Container)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Main)
Vue.use(Scrollbar)
Vue.use(Backtop)
Vue.use(Popover)
Vue.use(Menu)
Vue.use(Switch)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Dialog)
Vue.use(VDialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Checkbox)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Image)
Vue.use(Icon)
Vue.use(Avatar)
Vue.use(Tag)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Progress)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Link)
Vue.use(InputNumber)
Vue.use(Alert)
Vue.use(DropdownMenu)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Result)

Vue.use(Loading.directive)

const $message = (options) => {
  if (typeof options === 'string') {
    options = {
      message: options,
      offset: 56,
    }
    options.type = 'info'
  }
  return Message({
    ...options,
    offset: 56,
  })
}

  ;['success', 'warning', 'info', 'error'].forEach((type) => {
    $message[type] = (options) => {
      if (typeof options === 'string') {
        options = {
          message: options,
          offset: 56,
        }
      }
      options.type = type
      return Message(options)
    }
  })

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = $message
Vue.prototype.$message.closeAll = Message.closeAll
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
